/* unplugin-vue-components disabled */import script from "./goods-add.vue?vue&type=script&setup=true&lang=ts"
export * from "./goods-add.vue?vue&type=script&setup=true&lang=ts"

import "./goods-add.vue?vue&type=style&index=0&id=4ad68dc2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ad68dc2"]])

export default __exports__